import React from 'react';
import { Box } from '@mui/material';

interface Props {
  color: string;
  size?: string;
}

export const IndicatorDot = ({ color, size = '0.7rem' }: Props) => (
  <Box sx={{ width: size, height: size, borderRadius: '100%', backgroundColor: color }} />
);
